export function verificationProgress(status = {}) {
  const details = status.details;
  const mobile = status.authProvider === 'MOBILE';
  const social = ['GOOGLE', 'FACEBOOK'].includes(status.authProvider);
  const checks = [
    { label: 'Mobile number', complete: Boolean(status.phoneVerified), missing: 'Mobile number verification' },
    { label: 'Full name', complete: Boolean(details?.fullName?.trim()), missing: 'Full name' },
    ...(!social ? [{ label: 'Email address', complete: Boolean(details?.email), missing: 'Email address' }] : []),
    { label: 'GPS account address', complete: Boolean(details?.accountLocation?.location), missing: 'GPS account address' },
    ...(!social ? [{ label: 'Email verification', complete: Boolean(status.emailVerified && details?.email && status.email === details.email), missing: 'Email verification' }] : []),
    ...(!mobile ? [{ label: 'Account SMS confirmation', complete: Boolean(status.verified), missing: 'Account SMS confirmation' }] : []),
  ];
  return { checks, missing: checks.filter(check => !check.complete).map(check => check.missing) };
}
